<template>
  <div class="ttshop_user">
    <Header></Header>
    <Userheader></Userheader>
    <div class="ttshop_user">
      <div class="ttshop_usercon w clearfloat">
        <!-- 个人中心导航 -->
        <Usernavleft></Usernavleft>
        <div class="ttshop_useright">
          <!-- 关注的店铺 -->
          <div class="ttshop_coupon min_h">
            <!-- 暂无关注店铺时显示 -->
            <div class="ttshop_zwsc">
              <img
                class="img-default"
                src="../../assets/images/ttshop_sc.png"
                alt=""
              />
              <p>暂无关注任何店铺</p>
            </div>
            <!-- 关注店铺列表 -->
            <div class="ttshop_store">
              <div
                class="ttshop_storelist clearfloat"
                v-for="(item, index) in store_list"
                :key="index"
              >
                <div class="ttshop_storeleft">
                  <div class="ttshop_storetop clearfloat">
                    <p v-if="item.top_time==0" @click="topic(item.id)">置顶</p>
                    <p v-else @click="caceltopic(item.id)">取消置顶</p>
                    <p @click="shopFollowClick(item.id)">取消关注</p>
                  </div>
                  <div class="ttshop_storeleftimg">
                    <img class="img-default" :src="item.logo" alt="" />
                  </div>
                  <div class="ttshop_storeleftext">
                    <h5>{{ item.name }}</h5>
                    <div
                      class="ttshop_storepf clearfloat d-flex justify-content-center"
                    >
                      <span>服务体验</span>
                      <div class="ttshop_evaluatenums">
                        <el-rate
                          v-model="item.score"
                          disabled
                          score-template="{value}"
                        >
                        </el-rate>
                      </div>
                    </div>
                    <p>
                      粉丝:<span>{{ item.fictitious_follow }}</span>
                    </p>
                    <div class="ttshop_storebut clearfloat">
                      <!-- <router-link to="#">进入店铺</router-link> -->
                      <div @click="enterstore(item.id)">进入店铺</div>
                      <template v-if="item && item.id">
                        <div
                          v-if="item.customer_service"
                          @click="
                            webService(item.id, item.customer_service, 'mch')
                          "
                        >
                          联系客服
                        </div>
                      </template>
                      <template v-else>
                        <div
                          @click="webService(item.id, item.customer_service)"
                        >
                          联系客服
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
                <div class="ttshop_storeright">
                  <div class="ttshop_storetab clearfloat">
                    <p
                      :class="item.goods_list.active == 1 ? 'active' : ''"
                      @click="hotProducts(index, 1)"
                    >
                      热销
                    </p>
                    <p
                      :class="item.goods_list.active == 2 ? 'active' : ''"
                      @click="hotProducts(index, 2)"
                    >
                      新品
                    </p>
                  </div>
                  <div class="ttshop_storerightlist clearfloat">
                    <ul
                      class="clearfloat"
                      v-if="
                        item.goods_list.shoplist &&
                        item.goods_list.shoplist.length
                      "
                    >
                      <li
                        v-for="(i, b) in item.goods_list.shoplist"
                        :key="b"
                        @click="goodsdeta(i.id)"
                      >
                        <div class="ttshop_storeimg">
                          <img class="img-default" :src="i.cover_pic" alt="" />
                        </div>
                        <div class="ttshop_storetext">
                          <h5>{{ i.name }}</h5>
                          <p>￥{{ i.price }}</p>
                        </div>
                      </li>
                    </ul>
                    <div
                      class="not-goods d-flex align-items-center justify-content-center"
                      v-else
                    >
                      <img
                        class="img-default"
                        src="../../assets/images/not-goods.png"
                        alt=""
                      />
                      <span>店铺暂无商品</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="ttshop_myorderpage clearfloat">
              <!-- <el-pagination
                class="ttshop_pages"
                background
                layout="prev, pager, next"
                :total="40"
              ></el-pagination> -->
              <el-pagination
                class="ttshop_pages"
                background
                layout="prev, pager, next"
                :total="row_count"
                @prev-click="pages_perv"
                @next-click="page_next"
                @current-change="pageChange"
                :page-count="page_count"
                :hide-on-single-page="page_type"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>

<script>
import Header from "@/components/header/header";
import Foot from "@/components/foot/foot";
import Userheader from "./components/user_index";
import Usernavleft from "./components/user_navleft";
export default {
  components: {
    Header,
    Userheader,
    Usernavleft,
    Foot,
  },
  data() {
    return {
      value: 4,
      page: 0,
      store_tab: 1,
      store_list: [],
      store: "",
      mch_id: "",

      page_count: null,
      page_type: null,
      top_time: 0,
      row_count:'',
    };
  },
  mounted() {},
  created() {
    this.collectstore();
    this.getStore();
  },
  methods: {
    topic(id) {
      var that = this;
      this.$confirm("是否要将此店铺置顶", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.top_time = 1;
          that.storesticky(id);
        })
        .catch(() => {});
    },
    caceltopic(id) {
      var that = this;
      this.$confirm("是否要将此店铺取消置顶", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.top_time = 0;
          that.storesticky(id);
        })
        .catch(() => {});
    },
    //店铺置顶
    storesticky(id) {
      var that = this;
      this.$api
        .sticky_Topic({
          mch_id: id,
          top_time: this.top_time,
        })
        .then((res) => {
          if (that.top_time == 1) {
            this.$message({
              type: "success",
              message: "置顶成功",
              showClose: true,
              offset: 200,
              duration: 1000,
            });
          } else {
            this.$message({
              type: "success",
              message: "取消置顶",
              showClose: true,
              offset: 200,
              duration: 1000,
            });
          }
          that.collectstore();
        })
        .catch(() => {});
    },
    //上一页
    pages_perv() {
      this.page--;
    },
    // 下一页
    page_next() {
      this.page++;
    },
    // 输入分页
    pageChange(e) {
      this.page = e;
      this.common.backTop();
      this.collectstore();
    },
    //获取数量
    handleChange(value) {
      this.num = value;
    },
    // 取消关注店铺
    shopFollowClick(id) {
      this.$loading();
      let that = this;
      let params = {
        mch_id: id,
      };

      this.$api
        .shopUnFollow(params)
        .then((res) => {
          this.$loading().close();
          if (res.code == 0) {
            this.$message({
              showClose: true,
              message: "已取消关注",
              type: "success",
              offset: 200,
              duration: 1000,
            });
            this.collectstore();
          }
        })
        .catch((err) => {
          console.log(err);
          this.common.message(this, err);
        });
    },
    //进入店铺
    enterstore(id) {
      this.$router.push({
        path: "/shop",
        query: {
          mch_id: id,
        },
      });
    },
    //店铺中的热销和新品的切换
    hotProducts(index, b) {
      this.store_list[index].goods_list.active = b;
      if (b == 1) {
        this.store_list[index].goods_list.shoplist = this.store_list[
          index
        ].goods_list.best_goods;
      } else {
        this.store_list[index].goods_list.shoplist = this.store_list[
          index
        ].goods_list.hot_goods;
      }
    },
    // 获取商城配置
    getStore() {
      this.$api
        .store({})
        .then((res) => {
          this.contact_tel = res.data.contact_tel;
          this.store_option = res.data.store.option;
          this.store = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 平台客服
    webService(id, customer, type) {
      let goods = "";
      let store = this.store;
      let customer_service = customer;
      if (this.$store.state.user) {
        if (this.$store.state.user.token != "") {
          let url_str = this.common.webService(
            this,
            goods,
            store,
            type,
            customer_service
          );
          window.open(url_str);
        } else {
          this.$router.push({
            name: "signin",
            query: {
              redirect: this.$router.currentRoute.fullPath,
            },
          });
        }
      } else {
        this.$router.push({
          name: "signin",
          query: {
            redirect: this.$router.currentRoute.fullPath,
          },
        });
      }
    },
    //前往商品详情
    goodsdeta(id) {
      this.$router.push({
        path: "/pages/goods/goods",
        query: {
          id: id,
        },
      });
    },
    //获取收藏店铺消息
    collectstore() {
      let params = { page: this.page, type: this.store_tab };
      this.$api
        .collstore(params)
        .then((res) => {
          if (res.data.list) {
            for (var i = 0; i < res.data.list.length; i++) {
              res.data.list[i].score = Number(
                res.data.list[i].score.split(".")[0]
              );
              res.data.list[i].goods_list.active = 1;
              res.data.list[i].goods_list.shoplist =
                res.data.list[i].goods_list.best_goods;
            }
          }

          this.store_list = res.data.list;
          this.page_count=res.data.page_count;
          this.row_count=res.data.row_count;
        })
        .catch((err) => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.ttshop_coupon {
  width: 100%;
  background: #fff;
  padding: 20px;
  box-sizing: border-box;
  .ttshop_zwsc {
    width: 100%;
    padding-top: 200px;
    box-sizing: border-box;
    display: none;
    img {
      display: block;
      width: 85px;
      height: 80px;
      margin: 0 auto 20px;
    }
    p {
      font-size: 16px;
      color: #333;
      text-align: center;
    }
  }
  .ttshop_store {
    width: 100%;
    .ttshop_storelist {
      width: 100%;
      border: 1px solid #ebebeb;
      box-sizing: border-box;
      height: 318px;
      margin-bottom: 16px;
      .ttshop_storeleft {
        float: left;
        width: 220px;
        border-right: 1px solid #ebebeb;
        padding-top: 40px;
        box-sizing: border-box;
        height: 318px;
        position: relative;
        overflow: hidden;
        &:hover .ttshop_storetop {
          top: 0;
        }
        .ttshop_storetop {
          width: 100%;
          position: absolute;
          top: -34px;
          left: 0;
          transition: 0.5s;
          -moz-transition: 0.5s;
          -webkit-transition: 0.5s;
          -o-transition: 0.5s;
          p {
            position: relative;
            width: 50%;
            float: left;
            height: 34px;
            text-align: center;
            line-height: 34px;
            cursor: pointer;
            background: #999999;
            font-size: 12px;
            color: #fff;
            transition: 0.5s;
            -moz-transition: 0.5s;
            -webkit-transition: 0.5s;
            -o-transition: 0.5s;
            &::before {
              content: "";
              width: 1px;
              height: 34px;
              background: #fff;
              position: absolute;
              top: 0;
              right: 0;
            }
            &:last-child:before {
              display: none;
            }
            &:hover {
              background: #ff0e25;
            }
          }
        }
        .ttshop_storeleftimg {
          width: 100px;
          height: 100px;
          margin: 0 auto 24px;
          img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        .ttshop_storeleftext {
          width: 100%;
          padding: 0 10px;
          box-sizing: border-box;
          h5 {
            font-size: 14px;
            color: #333;
            line-height: 14px;
            font-weight: 600;
            text-align: center;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-bottom: 10px;
          }
          .ttshop_storepf {
            width: 100%;
            margin-bottom: 18px;
            span {
              float: left;
              font-size: 12px;
              color: #333;
              line-height: 18px;
              margin-right: 8px;
            }
          }
          p {
            font-size: 12px;
            color: #333;
            text-align: center;
            font-weight: 400;
            line-height: 12px;
            margin-bottom: 16px;
          }
          .ttshop_storebut {
            width: 100%;
            padding: 0 14px;
            box-sizing: border-box;
            a {
              float: left;
              width: 75px;
              height: 28px;
              color: #ff0e25;
              font-size: 12px;
              text-align: center;
              line-height: 28px;
              border-radius: 2px;
              border: 1px solid #ff0e25;
              margin-right: 16px;
              &:last-child {
                border-color: #ff9010;
                color: #ff9010;
                margin-right: 0;
              }
            }
            div {
              float: left;
              width: 75px;
              height: 28px;
              color: #ff0e25;
              font-size: 12px;
              text-align: center;
              line-height: 28px;
              border-radius: 2px;
              border: 1px solid #ff0e25;
              margin-right: 16px;
              &:last-child {
                border-color: #ff9010;
                color: #ff9010;
                margin-right: 0;
              }
            }
          }
        }
      }
      .ttshop_storeright {
        float: left;
        width: 728px;
        height: 318px;
        padding: 23px 21px;
        box-sizing: border-box;
        .ttshop_storetab {
          width: 100%;
          margin-bottom: 19px;
          p {
            float: left;
            width: 80px;
            height: 28px;
            text-align: center;
            line-height: 26px;
            font-size: 12px;
            color: #ff0e25;
            border-radius: 2px 0 0 2px;
            border: 1px solid #ff0e25;
            box-sizing: border-box;
            transition: 0.5s;
            -moz-transition: 0.5s;
            -webkit-transition: 0.5s;
            -o-transition: 0.5s;
            background: #fff;
            cursor: pointer;
            &:last-child {
              border-radius: 0 2px 2px 0;
            }
            &.active {
              background: #ff0e25;
              color: #fff;
            }
            &:hover {
              background: #ff0e25;
              color: #fff;
            }
          }
        }
        .ttshop_storerightlist {
          width: 100%;
          height: 80%;
          ul {
            li {
              float: left;
              width: 121px;
              margin-right: 20px;
              cursor: pointer;
              &:last-child {
                margin-right: 0;
              }
              &:hover .ttshop_storeimg img {
                -webkit-transform: scale(1.1);
                -moz-transform: scale(1.1);
                -o-transform: scale(1.1);
                -ms-transform: scale(1.1);
                transform: scale(1.1);
              }
              &:hover .ttshop_storetext h5 {
                color: #ff0e25;
              }
              .ttshop_storeimg {
                width: 100%;
                height: 121px;
                margin-bottom: 16px;
                overflow: hidden;
                img {
                  display: block;
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                  transition: 0.5s;
                  -moz-transition: 0.5s;
                  -webkit-transition: 0.5s;
                  -o-transition: 0.5s;
                }
              }
              .ttshop_storetext {
                width: 100%;
                h5 {
                  font-size: 12px;
                  color: #666;
                  font-weight: 400;
                  line-height: 18px;
                  height: 36px;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 2;
                  overflow: hidden;
                  margin-bottom: 15px;
                  transition: 0.5s;
                  -moz-transition: 0.5s;
                  -webkit-transition: 0.5s;
                  -o-transition: 0.5s;
                }
                p {
                  font-size: 16px;
                  color: #ff0e25;
                  font-weight: 500;
                  line-height: 16px;
                }
              }
            }
          }

          .not-goods {
            width: 100%;
            height: 100%;
            background: #f5f5f5;

            img {
              width: 100px;
              height: 100px;
              margin-right: 26px;
            }

            span {
              font-size: 14px;
              color: #9c9c9c;
            }
          }
        }
      }
    }
  }
  .ttshop_myorderpage {
    width: 100%;
    margin-top: 32px;
    .ttshop_pages {
      float: right;
    }
  }
}
</style>
